// extracted by mini-css-extract-plugin
module.exports = {"opportunityWrapper":"_863a781","showMoreWrapper":"_6e3eef5","invalidCombinationsMessage":"_2b920dd","hidden":"_b9489e8"};